import React from 'react'

function ContactScreen() {
    return (
        <div>
            Contattaci
        </div>
    )
}

export default ContactScreen
